






































import ShipList from '@/views/Admin/Ship/ShipList.vue';
import ViewInspection from '@/views/Inspection/ViewInspection.vue';
import ReInspection from '@/views/Inspection/ReInspection/ReInspection.vue';
import CopyReInspection from '@/views/Inspection/ReInspection/CopyReInspection.vue';
import ZoneList from '@/views/Admin/Ship/ZoneList.vue';
import FrameList from '@/views/Admin/Ship/FrameList.vue';
import TabCard from '@/components/Tabs.vue';
import {Vue, Component} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
@Component({
  computed: {...mapGetters(['currentTab'])},
  methods: {...mapActions(['setCurrentTab'])},
  components: {
    ViewInspection,
    ReInspection,
    CopyReInspection,
    ZoneList,
    FrameList,
    TabCard,
  },
})
export default class ReInspectionPanel extends Vue {
  inspectionId = this.$route.params.id;
  setCurrentTab: any;
  currentTab: any;
  initialTab: String = 'reinspection';
  tabs: Array<String> = ['viewinspection', 'reinspection', 'copyinspection'];

  // mounted() {
  //   this.setCurrentTabOnLoad(this.currentTab.child);
  // }
  // setCurrentTabOnLoad(activeTab) {
  //   this.setCurrentTab({parent: 'reinspection', child: activeTab});
  // }

  changeTab(activeTab) {
    // this.setCurrentTab({parent: 'viewinspection', child: activeTab});
  }
}
